import angular from 'angular';
import '../shared.module';

function cpClickOutside($document) {
  return {
    restrict: 'A',
    scope: { cpClickOutside: '&' },
    link(scope, element) {
      function handler(event) {
        if (!element[0].contains(event.target)) {
          scope.$apply(() => scope.cpClickOutside());
        }
      }

      $document.on('click', handler);
      scope.$on('$destroy', () => $document.off('click', handler));
    }
  };
}

cpClickOutside.$inject = ['$document'];

angular.module('app.shared').directive('cpClickOutside', cpClickOutside);
